import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getSimulatorInput } from 'gqlQueries/priceSimulator';
import { simulationInputDataParser } from 'parser/priceSimulator/priceSimulatorDataParser';
import { priceSimulatorDataContext } from 'contexts/PriceSimulatorContext';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { useLocation } from 'react-router-dom';
const errorMessage: string = 'Something went wrong!';

function useFetchSimulatorInput() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<Array<any>>([]);
    const [count, setCount] = useState<number>(0);
    const offsetRef = useRef(0);

    const [fetchSimulatorInput] = useLazyQuery(getSimulatorInput, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    const { appConfig } = useContext(UserContext);
    const { inputKeyMapping, levels } = getConfig('priceSimulator', appConfig);

    const location = useLocation();

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getCurrentPrices } = payload;
            // //if data present parse it
            if (getCurrentPrices?.pricesData?.length > 0) {
                setCount(getCurrentPrices?.count || 0); // TODO CHECK  with suman
                const parsedData: any = simulationInputDataParser(
                    getCurrentPrices?.pricesData,
                    levels,
                    inputKeyMapping,
                    location.pathname?.includes('new'),
                );
                if (offsetRef?.current) {
                    setData([...data, ...parsedData]); //reverse the array since the chart is reversed
                    return;
                }
                setData([...parsedData]);
                return;
            }
            setData([]);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchSimulatorInput: (variables: any) => {
            offsetRef.current = variables.variables.offset;
            setLoading(true);
            setError(null);
            fetchSimulatorInput(variables);
        },
    };
}

export { useFetchSimulatorInput };
